import { AdminLayout } from "../../layouts/admin";

export default AdminLayout;
